export var UserRmbLineType;
(function (UserRmbLineType) {
    UserRmbLineType["ALL"] = "all";
    UserRmbLineType["RMB_LINE"] = "rmb_line";
    UserRmbLineType["NOT_RMB_LINE"] = "not_rmb_line";
})(UserRmbLineType || (UserRmbLineType = {}));
//# sourceMappingURL=UserRmbLineType.js.map